"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amplitude = _interopRequireWildcard(require("@amplitude/marketing-analytics-browser"));
var _OneTrust = _interopRequireDefault(require("./OneTrust"));
var _utils = _interopRequireDefault(require("../../utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DEFAULT_AMPLITUDE_CONFIG = {
  trackingOptions: {
    ip_address: false
  },
  transport: amplitude.Types.TransportType.SendBeacon,
  minIdLength: 1
};
var conditionallyAddKey = function conditionallyAddKey(keyName, value, out) {
  if (value) {
    // the whole point of this method is to populate a single object with props,
    // so passing that object around by reference is the most performant
    // eslint-disable-next-line no-param-reassign
    out[keyName] = value;
  }
};
var SMAmplitude = /*#__PURE__*/function () {
  function SMAmplitude(config) {
    var _this = this;
    _classCallCheck(this, SMAmplitude);
    this.userProps = {};
    this.config = void 0;
    this.initialized = false;
    this.queuedEvents = [];
    this.config = config;
    this.initialize();

    // we'll listen in on OneTrust's global event for if the consent changes. this way,
    // we don't have to worry about race conditions should this library initialize before
    // the OneTrust one is available
    window.addEventListener('consent.onetrust', function () {
      return _this.handleConsentChange();
    });
  }

  /**
   * Initializes the Amplitude SDK
   */
  _createClass(SMAmplitude, [{
    key: "enabled",
    get:
    /**
     * Returns whether Amplitude events are enabled, either by configuration
     * or cookie acceptance through the OneTrust banner
     */
    function get() {
      var _user$session;
      var _this$config = this.config,
        amplitudeToken = _this$config.amplitudeToken,
        user = _this$config.user,
        overrideOneTrust = _this$config.overrideOneTrust;
      return (
        // we need an amplitude token...
        !!amplitudeToken &&
        // ...to not be impersonating a user...
        !(user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation) &&
        // ...and to not be opted out of functional cookies
        !(0, _OneTrust.default)(overrideOneTrust)
      );
    }
  }, {
    key: "initialize",
    value: function initialize() {
      if (!this.initialized && this.enabled) {
        var _this$config2 = this.config,
          amplitudeDeviceId = _this$config2.amplitudeDeviceId,
          amplitudeSessionId = _this$config2.amplitudeSessionId,
          amplitudeToken = _this$config2.amplitudeToken,
          user = _this$config2.user;
        var isAuthenticated = user.isAuthenticated,
          userId = user.id,
          group = user.group;
        var config = _objectSpread({}, DEFAULT_AMPLITUDE_CONFIG);
        conditionallyAddKey('deviceId', amplitudeDeviceId, config);
        conditionallyAddKey('sessionId', amplitudeSessionId, config);
        try {
          // due to the enabled check above, amplitudeToken is definitely not undefined
          amplitude.init(amplitudeToken, undefined, config);
          if (isAuthenticated) {
            var _group$membership;
            amplitude.setUserId(userId);
            if (group !== null && group !== void 0 && (_group$membership = group.membership) !== null && _group$membership !== void 0 && _group$membership.groupId) {
              var _group$membership2;
              amplitude.setGroup('teamId', group === null || group === void 0 ? void 0 : (_group$membership2 = group.membership) === null || _group$membership2 === void 0 ? void 0 : _group$membership2.groupId);
            }
          }
          this.hydrateDefaultUserProps();
          this.sendUserProperties();
        } catch (err) {
          // silently fail
        }
        this.initialized = true;
      }
    }

    /**
     * Sends a tracking event to Amplitude
     *
     * @param event The event and properties to send to Amplitude
     */
  }, {
    key: "track",
    value: function track(event) {
      var _document;
      var data = event.data;
      var amplitudeEvent = data.amplitudeEvent,
        amplitudeUserProperties = data.amplitudeUserProperties;

      // no amplitude event, nothing to do
      if (!amplitudeEvent) {
        return;
      }

      // if amplitude is disabled for any reason, stash the event for later
      // in the event it gets re-enabled so unsent events can get fired
      if (!this.enabled) {
        this.queuedEvents.push(event);
        return;
      }
      var eventData = _objectSpread({}, data);

      // remove values we don't want to pass along as event properties
      delete eventData.amplitudeEvent;
      delete eventData.amplitudeUserProperties;
      delete eventData.actionType;
      delete eventData.actionFlow;

      // if extra user props were in this event, send those along
      if (amplitudeUserProperties) {
        this.sendUserProperties(amplitudeUserProperties);
      }

      // "page viewed" events are a special event and we expect any event with those
      // words (in that order) to also send the current URL path as `urlPath`. we do
      // want to ensure we're in a browser environment before doing anything rash, though
      if (amplitudeEvent.indexOf('page viewed') > -1 && !eventData.urlPath && typeof document === 'object' && typeof ((_document = document) === null || _document === void 0 ? void 0 : _document.location) === 'object') {
        eventData.urlPath = document.location.pathname;
      }
      amplitude.track(amplitudeEvent, _objectSpread({}, eventData));
    }

    /**
     * Pulls out the default user properties that should be sent upon initialization
     *
     * @param user The user configuration from initialization
     */
  }, {
    key: "hydrateDefaultUserProps",
    value: function hydrateDefaultUserProps() {
      var user = this.config.user;
      var userProps = {};

      // decorate logged in user information
      if (user.isAuthenticated) {
        var _user$group, _user$group$membershi;
        conditionallyAddKey('languageId', user === null || user === void 0 ? void 0 : user.languageId, userProps);
        conditionallyAddKey('userPackageId', user === null || user === void 0 ? void 0 : user.package, userProps);
        conditionallyAddKey('userPackageName', (user === null || user === void 0 ? void 0 : user.packageCanonicalName) || (user === null || user === void 0 ? void 0 : user.packageName), userProps);
        conditionallyAddKey('userSubscriptionStatus', user === null || user === void 0 ? void 0 : user.subscriptionStatus, userProps);
        conditionallyAddKey('dateJoined', user === null || user === void 0 ? void 0 : user.joinedAt, userProps);
        conditionallyAddKey('dateSubscribed', user === null || user === void 0 ? void 0 : user.subscribedAt, userProps);
        conditionallyAddKey('userRole', (_user$group = user.group) === null || _user$group === void 0 ? void 0 : (_user$group$membershi = _user$group.membership) === null || _user$group$membershi === void 0 ? void 0 : _user$group$membershi.type, userProps);
        conditionallyAddKey('userDataCenter', user === null || user === void 0 ? void 0 : user.dataCenter, userProps);
        if (user.email) {
          var _user$email$split = user.email.split('@'),
            _user$email$split2 = _slicedToArray(_user$email$split, 2),
            emailDomain = _user$email$split2[1];
          if (emailDomain && emailDomain.indexOf('.') > -1) {
            userProps.emailDomain = emailDomain;
          }
        }
      }

      // EP-1743: decorate with EP cookie values
      userProps.userSMSessionId = (0, _utils.default)('ep201');
      userProps.userSMPersistentId = (0, _utils.default)('ep202');
      this.userProps = userProps;
    }

    /**
     * Sends default user properties on initialization and additional user properties
     * any time via an Amplitude identify event.
     *
     * @param extraUserProps Additional user properties to send with the defaults
     */
  }, {
    key: "sendUserProperties",
    value: function sendUserProperties(extraUserProps) {
      // only send user props on initialization or if there are extra props to be sent
      if (!this.initialized || extraUserProps) {
        var identify = new amplitude.Identify();
        var userProps = _objectSpread(_objectSpread({}, this.userProps), extraUserProps || {});
        Object.keys(userProps).forEach(function (key) {
          identify.set(key, userProps[key]);
        });
        amplitude.identify(identify);
      }
    }

    /**
     * Event handler for when a user changes OneTrust cookie consent
     */
  }, {
    key: "handleConsentChange",
    value: function handleConsentChange() {
      var _this2 = this;
      // bail if amplitude cookies are now rejected
      if (!this.enabled) {
        return;
      }

      // if consent has been granted where it wasn't before, initialize everything and send any queued events
      if (!this.initialized) {
        this.initialize();
      }
      this.queuedEvents.forEach(function (event) {
        return _this2.track(event);
      });
      this.queuedEvents = [];
    }
  }]);
  return SMAmplitude;
}();
exports.default = SMAmplitude;
module.exports = exports.default;
//# sourceMappingURL=index.js.map